module.exports = __webpack_public_path__ + "img/almenu_gomb_kutatasok_partner_aktiv.0ca888ef.png";